module.exports = __webpack_public_path__ + "img/success4.d4c74011.png";